module.exports = "a";


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/async/loaders/syncloader.js!./loaders/async/loaders/syncloader.js!./loaders/async/loaders/syncloader.js!./loaders/async/a.js
 ** module id = 3
 ** module chunks = 0
 **/